import request from '@/utils/request'


// 查询发现板块-评论回复列表
export function listDiscoveryReply(query) {
  return request({
    url: '/discovery/discovery/reply/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询发现板块-评论回复分页
export function pageDiscoveryReply(query) {
  return request({
    url: '/discovery/discovery/reply/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询发现板块-评论回复详细
export function getDiscoveryReply(data) {
  return request({
    url: '/discovery/discovery/reply/detail',
    method: 'get',
    params: data
  })
}

// 新增发现板块-评论回复
export function addDiscoveryReply(data) {
  return request({
    url: '/discovery/discovery/reply/add',
    method: 'post',
    data: data
  })
}

// 修改发现板块-评论回复
export function updateDiscoveryReply(data) {
  return request({
    url: '/discovery/discovery/reply/edit',
    method: 'post',
    data: data
  })
}

// 删除发现板块-评论回复
export function delDiscoveryReply(data) {
  return request({
    url: '/discovery/discovery/reply/delete',
    method: 'post',
    data: data
  })
}
